import { gql } from "@apollo/client";

export const getTeamsQuery = gql`
    query LoadTeams {
        getTeams {
            id
            name
            description
            createdBy
            createdAt
            updatedBy
            updatedAt
        }
    }
`;

export const getSkillsQuery = gql`
    query LoadSkills {
        getSkills {
            name
        }
    }
`;

export const getAgentsWithSkill = gql`
    query getAgentsWithSkill($name: String!) {
        getAgentsWithSkill(name: $name) {
            id
            name
        }
    }
`;
